module.exports = __webpack_public_path__ + "static/media/haase.4fc1a514.png";